import { KeyboardArrowDown } from "@mui/icons-material";
import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { instance } from "./config";
import Select from "react-select";

function DropDownList({
  selected,
  title,
  endpoint,
  selectedItem,
  setSelectedItem,
  optionList,
  disabled,
  hierarchyUpdated,
  required,
  withParams,
  params,
  menuPortal
}) {
  const [options, setOptions] = React.useState([]);
  const [isLoading, setLoading] = React.useState(true);
  const handleChange = (value, label) => {
    setSelectedItem({ Id: value, Nombre: label });
  };
  async function getItems() {
    await instance
      .get(endpoint)
      .then((res) => {
        setOptions(
          res.data.map((item) => {
            return { label: item.Nombre, value: item.Id };
          })
        );
        setLoading(false);
      })
      .catch((error) => { })
      .finally();
  }

  if (isLoading && endpoint && endpoint !== undefined) {
    if(withParams===true && params === undefined){}
    else{
      getItems();
    }  
  } 
  else if (isLoading && optionList) {
    setOptions(
      optionList.map((item) => {
        return { label: item.Nombre, value: item.Id };
      })
    );
    setLoading(false);
  }
  
  useEffect(() => {
    getItems();
  }, [endpoint]);

  useEffect(() => {
    if (hierarchyUpdated !== undefined) {
      setSelectedItem({ Id: "", Nombre: "" });
    }
  }, [hierarchyUpdated]);

  useEffect(() => { }, [selectedItem]);

  if (isLoading && endpoint && options) {
    return <em>Cargando...</em>;
  } else {
    return (
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginTop: 2,
        }}
      >
        <Grid item>
          <Select
            form
            name={`ddl_${title}`}
            isDisabled={disabled}
            placeholder={`${title}${required ? " *" : ""}`}
            options={options}
            onChange={(choice) => handleChange(choice.value, choice.label)}
            required={required}
            menuPortalTarget={menuPortal ? document.body : undefined}
            styles={menuPortal ? { menuPortal: base => ({ ...base, zIndex: 9999 }) } : undefined}
            menuPlacement={menuPortal ? "auto" : undefined}
            maxMenuHeight={menuPortal ? 200 : undefined}
            defaultValue={
              selected
                ? options.find((item) => item.value === selected)
                : "Select"
            }
            value={
              selected
                ? options.find((item) => item.value === selectedItem.Id) || null
                : undefined
            }
          />
        </Grid>
      </Grid>
    );
  }
}

export { DropDownList };
